<template>
  <div class="header" :style="{'background-image': 'url(' + require('@/assets/header.png') + ')'}">
    <div class="color"></div>
    <div class="">
      <div class="header-main">
        <h1 class="header-main-title">СВЕТЛАНА РАМБЕЛЛИ</h1>
        <h2 class="header-main-discription">Практикующий психолог</h2>
      </div>
      <p class="header-discription text-uppercase">Психологическое консультирование <br>взрослых <span>онлайн</span></p>
      <div class="header-contact">
        <div class="header-contact-info">
          <span>WhatsApp:</span>
          <a href="https://wa.me/393200946598" target="_blank"><span class="numbers"><u><span class="Raleway">+</span>393200946598</u></span></a>
        </div>
        <div class="header-contact-info">
          <span>Viber:</span>
          <a href="viber://chat?number=393200946598"><span class="numbers"><u><span class="Raleway">+</span>393200946598</u></span></a>
        </div>
        <a href="mailto:svetlanarambelli@gmail.com"><p class="header-contact-mail"><u>svetlanarambelli@gmail.com</u></p></a>
      </div>
      <button class="button mt-5" @click="$router.push('/services')">Записаться <under-arrow/></button>
    </div>
    <div class="learn-more" v-scroll-to="'#about'">
      <p>УЗНАТЬ БОЛЬШЕ</p>
      <under-arrow/>
    </div>
  </div>
</template>

<script>
  import UnderArrow from '@/components/icons/UnderArrow';
  export default {
    name: "Header",
    components: {UnderArrow}
  }
</script>

<style lang="scss">
  body {
    .numbers {
      font-weight: 400;
      font-family: 'Nunito', sans-serif !important;
      .Raleway {
        font-family: 'Raleway', sans-serif;
      }
    }
  }
  .header {
    width: 100%;
    height: 100vh;
    background-position: center;
    background-size: cover;
    position: relative;
    font-family: 'Comfortaa', cursive;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .button {
      width: 181px;
      height: 48px;
      border-radius: 9px;
      background-color: #55cce7;
      margin-right: 32px;
      font-family: 'Raleway', sans-serif;
      font-size: 17px;
      font-weight: 600;
      border: none;
      position: relative;
      z-index: 3;
      color: #ffffff;
      margin-top: 24px;
      margin-left: auto;
      margin-right: auto;
      display: block;
      svg {
        transform: rotate(-90deg);
        margin-left: 15px;
      }
    }
    &-main {
      position: relative;
      z-index: 2;
      padding: 24px 32px;
      border-top: 0.5px solid #55cce7;
      border-bottom: 0.5px solid #55cce7;
      text-align: center;
      &-title {
        font-size: 52px;
        font-weight: bold;
        color: #ffffff;
        margin: 0;
      }
      &-discription {
        font-size: 32px;
        color: #ffffff;
        margin: 24px 0 0 0;
      }
    }
    &-discription {
      position: relative;
      z-index: 2;
      width: 100%;
      color: #fff;
      text-align: center;
      font-size: 24px;
      margin-top: 32px;
      font-family: 'Raleway', sans-serif;
      span {
        font-weight: 600;
      }
    }
    &-contact {
      position: relative;
      z-index: 2;
      font-size: 24px;
      color: #ffffff;
      font-family: 'Raleway', sans-serif;
      width: 325px;
      margin-left: auto;
      -webkit-font-feature-settings: "lnum";
      -moz-font-feature-settings: "lnum";
      font-feature-settings: "lnum";
      margin-right: auto;
      &-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        margin-top: 32px;
        span:last-child {
          color: #55cce7;
          font-family: 'Raleway', sans-serif;
          text-decoration: underline;
          -webkit-font-feature-settings: "lnum" !important;
          -moz-font-feature-settings: "lnum" !important;
          font-feature-settings: "lnum" !important;
        }
      }
      &-mail {
        color: #55cce7 !important;
        text-decoration: underline;
      }
    }
    .learn-more {
      position: absolute;
      left: 50%;
      text-align: center;
      bottom: 32px;
      margin-left: -73.3px;
      cursor: pointer;
      p {
        font-size: 17px;
        color: #ffffff;
        font-family:  'Raleway', sans-serif;
      }
      svg {
        margin-top: 16px;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
  .color {
    position: absolute;
    background:  rgba(31, 31, 31, 0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media screen  and (max-width: 768px){
    .header {
      padding: 24px;
     &-main {
       margin-top: 134px;
      &-title {
        font-size: 32px;
        font-weight: bold;
        color: #ffffff;
      }
      &-discription {
        font-size: 24px;
        color: #ffffff;
      }
     }
      &-discription {
        font-size: 22px;
        color: #ffffff;
      }
      &-contact {
        &-info {
          font-size: 22px;
          color: #ffffff;
          span:last-child {

          }
        }
        &-mail {
          text-align: center;
          font-size: 22px;
          color: #ffffff;
        }
      }
      .learn-more {

        p {
        }
        svg {

        }
      }
    }
  }
  @media screen and (max-height: 750px){
    .header {
      padding: 20px;
      height: auto !important;
      &-main {
        margin-top: 136px;
      }
      .button {
        margin-bottom: 186px;
      }
    }
  }
  @media screen  and (max-width: 650px){
    .header {
      padding: 20px;
      height: auto;
      &-main {
        padding: 24px 4px;
        &-title {
          font-size: 26px;
          font-weight: bold;
          color: #ffffff;
        }
        &-discription {
          font-size: 18px;
          color: #ffffff;
        }
      }
      &-discription {
        font-size: 17px;
        color: #ffffff;
      }
      &-contact {
        width: 250px;
        &-info {
          font-size: 17px;
          color: #ffffff;
          span:last-child {

          }
        }
        &-mail {
          text-align: center;
          font-size: 17px;
          color: #ffffff;
        }
      }
      .button {
        margin-bottom: 186px;
      }
      .learn-more {

        p {
        }
        svg {

        }
      }
    }
  }
</style>